const debug = false;
const name = 'store/modules/util.js';

const state = {
  isMobile: false
}

const getters = {}

const mutations = {
  /**
   * @protected setMobile mutation
   * @param {*} mobile
   */
  setMobile (state, isMobile) {
    if (debug) console.log(name,'mutation setUser() isMobile:',isMobile)
    state.isMobile = isMobile
  }
}

const actions = {}

export default {
  namespaced: true,

  state,
  getters,
  mutations,
  actions
}